import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { useSettings } from 'app/main/components';
import { type QueryType } from 'app/main/components/hooks/useQuery';
import QueryBuilder from 'app/main/components/filter/QueryBuilder';

interface AddRowsQueryDialogProps {
	title: string;
	currentTree: QueryType['currentTree'];
	queryConfig: QueryType['queryConfig'];
	handleQueryChange: QueryType['handleQueryChange'];
	showResults: VoidFunction;
	closeDialog: VoidFunction;
}

export default function AddRowsQueryDialog(props: AddRowsQueryDialogProps) {
	const { t } = useSettings();

	return (
		<>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent>
				<QueryBuilder
					currentTree={props.currentTree}
					queryConfig={props.queryConfig}
					handleQueryChange={props.handleQueryChange}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.closeDialog}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button color="secondary" onClick={props.showResults}>
					{t('DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
		</>
	);
}
